import HealthStatus from './HealthStatus.container'

export default HealthStatus;